<p-messages [enableService]="true" [closable]="false"></p-messages>

<h3 data-cy="titulo-pagina">Pesquisar perfis profissiográficos e relatórios dos candidatos</h3>

<sgp-filtro-pesquisar-laudo />
<sgp-resultado-pesquisar-laudo />
